<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <LoadingSpinner v-if="isLoading">
                </LoadingSpinner>
                <donation-form v-else @request-payments="requestPayment">
                </donation-form>

                <TossPayment v-if="showTosspaymentModal" :paymentInfo="paymentInfo"
                    @close="showTosspaymentModal = false">
                </TossPayment>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TossPayment from '@/components/toss/TossPayment.vue';
import DonationForm from '@/views/PaymentView/DonationForm.vue';
import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';

import { CURRENCY_CODE } from '@/views/PaymentView/constants';

import { accountApi } from '@/api/api';

export default {
    name: "MemberDonation",
    components: {
        DonationForm,
        TossPayment,
        LoadingSpinner,
    },
    data() {
        return {
            showTosspaymentModal: false,
            paymentInfo: {
                orderName: "기부(Donation)",
                payerName: null,
                payerEmail: null,
                amount: {
                    currency: null,
                    value: 0,
                },
                memo: null,
            },
            isLoading: false,
        }
    },
    methods: {
        changeTosspaymentModalStatus() {
            this.showTosspaymentModal = !this.showTosspaymentModal;
        },
        requestPayment(data) {
            this.isLoading = true;
            this.updatePaymentInfo(data);

            if (this.paymentInfo.amount.currency === CURRENCY_CODE.KRW) {
                this.changeTosspaymentModalStatus();
            } else {
                this.requestPaypal();
            }
            this.isLoading = false;
        },

        updatePaymentInfo(data) {
            this.paymentInfo.payerName = data.payer;
            this.paymentInfo.payerEmail = data.email;
            this.paymentInfo.amount.currency = data.currency_code;
            this.paymentInfo.amount.value = data.amount;
            this.paymentInfo.memo = data.memo;
        },

        async requestPaypal() {
            const data = {
                "order_name": this.paymentInfo.orderName,
                "payer_name": this.paymentInfo.payerName,
                "payer_email": this.paymentInfo.payerEmail,
                "amount": this.paymentInfo.amount.value,
                "currency_code": this.paymentInfo.amount.currency,
                "memo": this.paymentInfo.memo,
            }

            this.isLoading = true;
            await accountApi.requestCreatePaypalOrder(data)
                .then((response) => {
                    if (response && response.status === 200) {
                        window.location.href = response.data.approve_url;
                    } else {
                        this.notifyVue({ message: this.$t('alert.failed_request'), style: "danger" });
                    }
                })
                .catch(() => {
                    this.notifyVue({ message: this.$t('alert.failed_request'), style: "danger" });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        /* ****************************************************************************************
         * 알럿
         * ****************************************************************************************/
        notifyVue({
            vertical = "top",
            horizontal = "right",
            message = "",
            style = "primary",
            icon = "priority_high",
        } = {}) {
            this.$notify({
                timeout: 8000,
                message: message,
                icon: icon,
                type: style,
                horizontalAlign: horizontal,
                verticalAlign: vertical,
            });
        }
    },
}
</script>
<style></style>